function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./categories'),
  STORE_CATEGORIES = _require.STORE_CATEGORIES;
var Listing = /*#__PURE__*/function () {
  function Listing() {
    var _data$id, _data$quantity, _data$price, _data$slip_id, _ref, _data$block_id_listed, _ref2, _data$transaction_id_, _ref3, _data$longest_chain_l, _data$block_id_sold, _data$transaction_id_2, _data$longest_chain_s, _data$settlement_pend, _data$on_chain, _data$approved;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Listing);
    this.id = (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : 0;
    this.signature = data.signature || '';
    this.nft_id = data.nft_id || '';
    this.seller = data.seller || '';
    this.category = data.category || STORE_CATEGORIES.OTHER;
    this.quantity = (_data$quantity = data.quantity) !== null && _data$quantity !== void 0 ? _data$quantity : 1;
    this.price = (_data$price = data.price) !== null && _data$price !== void 0 ? _data$price : 0;
    this.web3_ticker = String(data.web3_ticker || '').trim().toUpperCase();
    this.web3_amount = String(data.web3_amount || '').trim();
    this.access_hash = data.access_hash || '';
    this.access_script = data.access_script || '';
    this.p2sh_address = data.p2sh_address || '';
    this.slip_id = (_data$slip_id = data.slip_id) !== null && _data$slip_id !== void 0 ? _data$slip_id : 0;
    this.block_id_listed = Number((_ref = (_data$block_id_listed = data.block_id_listed) !== null && _data$block_id_listed !== void 0 ? _data$block_id_listed : data.block_id) !== null && _ref !== void 0 ? _ref : 0);
    this.block_hash_listed = data.block_hash_listed || data.block_hash || '';
    this.transaction_id_listed = Number((_ref2 = (_data$transaction_id_ = data.transaction_id_listed) !== null && _data$transaction_id_ !== void 0 ? _data$transaction_id_ : data.transaction_id) !== null && _ref2 !== void 0 ? _ref2 : 0);
    this.longest_chain_listed = (_ref3 = (_data$longest_chain_l = data.longest_chain_listed) !== null && _data$longest_chain_l !== void 0 ? _data$longest_chain_l : data.longest_chain) !== null && _ref3 !== void 0 ? _ref3 : 1;
    this.block_id_sold = Number((_data$block_id_sold = data.block_id_sold) !== null && _data$block_id_sold !== void 0 ? _data$block_id_sold : 0);
    this.block_hash_sold = data.block_hash_sold || '';
    this.transaction_id_sold = Number((_data$transaction_id_2 = data.transaction_id_sold) !== null && _data$transaction_id_2 !== void 0 ? _data$transaction_id_2 : 0);
    this.longest_chain_sold = (_data$longest_chain_s = data.longest_chain_sold) !== null && _data$longest_chain_s !== void 0 ? _data$longest_chain_s : 0;
    this.settlement_pending = Number((_data$settlement_pend = data.settlement_pending) !== null && _data$settlement_pend !== void 0 ? _data$settlement_pend : 0) ? 1 : 0;
    this.on_chain = (_data$on_chain = data.on_chain) !== null && _data$on_chain !== void 0 ? _data$on_chain : 1;
    this.utxo_slip1 = data.utxo_slip1 || '';
    this.utxo_slip2 = data.utxo_slip2 || '';
    this.utxo_slip3 = data.utxo_slip3 || '';
    this.created_at = data.created_at || 0;
    this.updated_at = data.updated_at || data.created_at || 0;
    this.approved = Number((_data$approved = data.approved) !== null && _data$approved !== void 0 ? _data$approved : 0) || 0;
    this.risk = data.risk === 'Low' || data.risk === 'Medium' || data.risk === 'High' || data.risk === 'Dangerous' ? data.risk : '';

    // compatibility aliases used by fulfillment helpers
    this.block_id = this.block_id_listed;
    this.block_hash = this.block_hash_listed;
    this.transaction_id = this.transaction_id_listed;
    if (!this.p2sh_address && this.utxo_slip2) {
      try {
        var slip2 = JSON.parse(this.utxo_slip2);
        this.p2sh_address = slip2.publicKey || '';
      } catch (err) {
        // ignore malformed slip json
      }
    }
  }
  return _createClass(Listing, [{
    key: "isListedOnChain",
    value: function isListedOnChain() {
      return Number(this.longest_chain_listed) === 1;
    }

    /**
     * The listing inclusion is on the longest chain and a canonical spend exists.
     * longest_chain_sold is the snapshot of that spend. block_id_sold > 0 with the
     * flag at 0 is a sale inclusion that is not currently canonical.
     */
  }, {
    key: "isSoldOnChain",
    value: function isSoldOnChain() {
      return this.isListedOnChain() && Number(this.longest_chain_sold) === 1;
    }
  }, {
    key: "isSettlementPending",
    value: function isSettlementPending() {
      return Number(this.settlement_pending) === 1;
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      return this.isListedOnChain() && !this.isSoldOnChain() && !this.isSettlementPending();
    }
  }]);
}();
module.exports = Listing;